import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#i1632159327__a)" }, [
      _createElementVNode("path", {
        fill: "#6E6E6E",
        d: "m13.162 5.142-2.885-2.704a1.59 1.59 0 0 0-2.182 0L5.248 5.114l.731.709 2.702-2.546v8.215c0 .83-.692 1.501-1.548 1.501H3.181V14h3.952c1.423 0 2.577-1.119 2.577-2.499V3.287l2.73 2.573.732-.709s0-.009-.01-.018v.01Z"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "i1632159327__a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M3.181 2h10v12h-10z"
        })
      ])
    ], -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "arrow-out"}) } }